function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSettingsUnitsFrequencies = function SvgSettingsUnitsFrequencies(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.86,29.38v1.74A.87.87,0,0,1,21,32H15.73a.87.87,0,0,1-.87-.88V18.88a.87.87,0,0,1,.87-.88H21a.87.87,0,0,1,.88.88v1.74H19.45a.22.22,0,0,0-.22.22v.44a.22.22,0,0,0,.22.22h2.41v1.75H19.45a.22.22,0,0,0-.22.22v.44a.21.21,0,0,0,.22.21h2.41v1.76H19.45a.21.21,0,0,0-.22.21v.44a.22.22,0,0,0,.22.22h2.41V28.5H19.45a.22.22,0,0,0-.22.22v.44a.22.22,0,0,0,.22.22Z",
    style: {
      fill: "#666"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.14,24.75a5.81,5.81,0,1,1-5.81-5.81A5.81,5.81,0,0,1,37.14,24.75Zm-4.08,2.33.66-.91a.28.28,0,0,0-.06-.39L32.17,24.7V21.47a.27.27,0,0,0-.28-.28H30.77a.28.28,0,0,0-.29.28v3.94a.29.29,0,0,0,.12.23l2.07,1.5A.28.28,0,0,0,33.06,27.08Z",
    style: {
      fill: "#666"
    }
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSettingsUnitsFrequencies, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/settings-units-frequencies.190fde4f.svg";
export { ForwardRef as ReactComponent };